'use strict';

function waitForElement(selector) {
  return new Promise(function(resolve, reject) {
    var element = document.querySelector(selector);

    if(element) {
      resolve(element);
      return;
    }

    var observer = new MutationObserver(function(mutations) {
      mutations.forEach(function(mutation) {
        var nodes = Array.from(mutation.addedNodes);
        for(var node of nodes) {
          if(node.matches && node.matches(selector)) {
            observer.disconnect();
            resolve(node);
            return;
          }
        };
      });
    });

    observer.observe(document.documentElement, { childList: true, subtree: true });
  });
}

// shim layer with setTimeout fallback
const requestAnimFrame = (function () {
  return window.requestAnimationFrame ||
    window.webkitRequestAnimationFrame ||
    window.mozRequestAnimationFrame ||
    function (callback) {
      window.setTimeout(callback, 3000 / 60);
    };
})();

function waitUntil(test) {
  return new Promise(function(resolve){
    (function poll() {
      if (!test()) return requestAnimFrame(poll, 50);
      return resolve();
    })();
  });
};

//-----------

const getParam = (name, optSearch) => {
  'use strict';
  optSearch = optSearch || location.search;
  name = name.replace(/[\[]/, '\\[').replace(/[\]]/, '\\]');
  var regex = new RegExp('[\\?&]' + name + '=([^&#]*)'),
    results = regex.exec(optSearch);
  return results === null ?
    '' : decodeURIComponent(results[1].replace(/\+/g, ' '));
};

//-----------

// const loadScript = (url, optCallback) => {
//   'use strict';
//   const ga = document.createElement('script');
//   ga.type = 'text/javascript';
//   ga.async = true;
//   ga.src = url;
//   if (typeof optCallback === 'function') {
//     ga.onload = optCallback;
//   }
//   const s = document.getElementsByTagName('script')[0];
//   s.parentNode.insertBefore(ga, s);
// };

//---- A/B Treatments ----

  /*
  TO-DO:
  - bolierplate for siloed experiments
  */

  const apply_wndr27 = () => {
    let variation = sessionStorage.getItem("WNDR-27");
    let qa = getParam("qa");

    console.log(`init WNDR-27 -- v0.1`);
    document.documentElement.classList.add("wndr27");

    //vimeo
    const params = `?autoplay=1&loop=1&autopause=0&muted=1&quality=540p&controls=0`;
    const landscape_video = `<iframe src="https://player.vimeo.com/video/539291135${params}" width="640" height="360" frameborder="0" allow="autoplay; fullscreen; picture-in-picture" allowfullscreen></iframe><span></span><span></span>`;
    const square_video = `<iframe src="https://player.vimeo.com/video/539291351${params}" width="640" height="640" frameborder="0" allow="autoplay; fullscreen; picture-in-picture" allowfullscreen></iframe><span></span><span></span>`;

    //youtube
    // const params = `?&mute=1&autoplay=1&loop=1&rel=0&modestbranding=1&autohide=0&showinfo=1&controls=1`;
    // const params = `&autoplay=1&controls=0&loop=1&modestbranding=1&rel=0&mute=1`;
    // const params = `enablejsapi=1&origin=wandererbracelets.com`;
    // const landscape_video = `<iframe width="560" height="315" src="https://www.youtube.com/embed/O4G_8vInSrs?${params}" frameborder="0"></iframe><span></span>`;
    // const square_video = `<iframe width="560" height="560" src="https://www.youtube.com/embed/FhpIfpWic34?${params}" frameborder="0"></iframe><span></span>`;

    /*
      v1
      - desktop PDP: add video in left hand space in empty area beneath product media (left of details)
      - mobile PDP: add video
      - desktop PCP: add video to the grid as the last item in the first row (offset remaining products)
      - mobile PCP: add video
    */

    const apply = () => {

      if(document.querySelector('body').classList.value.indexOf("collection-banner") > -1 && window.location.href.indexOf("/collections") > -1){
        //this is a PCP
        waitForElement(".products").then(list => {
          let products = list.querySelectorAll('.four.columns');
          if(window.innerWidth > 768){
            //desktop
            products[3].insertAdjacentHTML("beforebegin", `
              <div class="four columns js-video--square">${square_video}</div>
            `);
          } else {
            //mobile
            products[1].insertAdjacentHTML("afterend", `
              <div class="two columns js-video--landscape">${landscape_video}</div>
            `);
          }
        }).catch();
      }

      if(document.querySelector('body').classList.value.indexOf("product") > -1 && window.location.href.indexOf("/products") > -1){
        //this is a PDP
        if(window.innerWidth > 768){
          //desktop
          waitForElement('.product_gallery_wrapper').then(media => {
            media.insertAdjacentHTML("afterend",`
              <div class="js-video--landscape">${landscape_video}</div>
            `);
          }).catch();
        } else {
          //mobile
          waitForElement('.product__accordion.accordion').then(desc => {
            desc.insertAdjacentHTML("beforebegin",`
              <div class="js-video--landscape">${landscape_video}</div>
            `);
          }).catch();
        }
      }

    }; // apply()

    //init
    apply();
    setTimeout(() => {
      re_apply();
    }, 250);

    const re_apply = () => {
      let videos = document.querySelectorAll('[class*="js-video--"]');
      for(let i = 0; i < videos.length; i++){
        videos[i].remove();
      }
      setTimeout(() => {
        apply();
      }, 250);
    };

    let desktop_active = true;
    if(window.innerWidth < 768){
      desktop_active = false;
    }
    window.addEventListener('resize', () => {
      if(window.innerWidth < 768 && desktop_active === true){
        desktop_active = false;
        console.log("teardown desktop treatment and apply mobile");
        setTimeout(() => {
          re_apply();
        }, 500);
      } else if(window.innerWidth > 768 && desktop_active === false) {
        desktop_active = true;
        console.log("teardown mobile treatment and apply desktop");
        setTimeout(() => {
          re_apply();
        }, 500);
      }
    });


  };

  const apply_wndr26 = () => {
    let variation = sessionStorage.getItem("WNDR-26");
    let qa = getParam("qa");
    console.log(`init WNDR-26${variation} -- v0.1`);

    const dateObj = new Date();
    const month = dateObj.getMonth() + 1;
    const day = dateObj.getDate();
    const hours = dateObj.getHours();

    let is_morning = true;
    if(hours > 12){
      is_morning = false;
    }

    let collection_href = "/collections/gifts-for-mom"; //v1
    let landing_href = "/pages/mothersday"; //v2
    let print_cta = `<a class="promo_banner--fancybox" href="//cdn.shopify.com/s/files/1/0586/2621/files/WEB_2020GiftModal_IMG-01_610x.jpg?v=1607009569" data-desktop-href="//cdn.shopify.com/s/files/1/0586/2621/files/WEB_2020GiftModal_IMG-01_610x.jpg?v=1607009569" data-mobile-href="//cdn.shopify.com/s/files/1/0586/2621/files/WEB_GiftPreviewModal2020_mobile_317x.jpg?v=1607009586" alt="">Print-at-Home Card</a>`;

    let v1_html, v2_html;

    if(month === 4){
      if(day < 29){
        // Apr 12 - Apr 28
        v1_html = `<a href="${collection_href}"><b>Give Mom THE PERFECT GIFT this year.</b></a>`;
        v2_html = `<a href="${landing_href}"><b>Give Mom THE PERFECT GIFT this year.</b></a>`;
      } else {
        // Apr 29 - Apr 30
        v1_html = `<a href="${collection_href}"><b>LAST DAY to GIFT MOM with STANDARD Shipping! Get a ${print_cta} with every order TODAY</b></a>`;
        v2_html = `<a href="${landing_href}"><b>LAST DAY to GIFT MOM with STANDARD Shipping! Get a ${print_cta} with every order TODAY</b></a>`;
        if(day === 30 && !is_morning){
          // Apr 30 PM
          v1_html = `<a href="${collection_href}"><b>It's NOT too late for MOM with PRIORITY Shipping & Get a ${print_cta} with every order Today!</b></a>`;
          v2_html = `<a href="${landing_href}"><b>It's NOT too late for MOM with PRIORITY Shipping & Get a ${print_cta} with every order Today!</b></a>`;
        }
      }
    } else if(month === 5){
      if(day < 3){
        // May 1 - May 2
        v1_html = `<a href="${collection_href}"><b>It's NOT too late for MOM with PRIORITY Shipping & Get a ${print_cta} with every order Today!</b></a>`;
        v2_html = `<a href="${landing_href}"><b>It's NOT too late for MOM with PRIORITY Shipping & Get a ${print_cta} with every order Today!</b></a>`;
      } else if(day === 3){
        // May 3
        if(is_morning){
          v1_html = `<a href="${collection_href}"><b>It's NOT too late for MOM with PRIORITY Shipping & Get a ${print_cta} with every order Today!</b></a>`;
          v2_html = `<a href="${landing_href}"><b>It's NOT too late for MOM with PRIORITY Shipping & Get a ${print_cta} with every order Today!</b></a>`;
        } else {
          v1_html = `<a href="${collection_href}"><b>LAST MINUTE GIFT? Get a ${print_cta} with every order Today!</b></a>`;
          v2_html = `<a href="${landing_href}"><b>LAST MINUTE GIFT? Get a ${print_cta} with every order Today!</b></a>`;
        }
      } else {
        // May 4+
        v1_html = `<a href="${collection_href}"><b>LAST MINUTE GIFT? Get a ${print_cta} with every order Today!</b></a>`;
        v2_html = `<a href="${landing_href}"><b>LAST MINUTE GIFT? Get a ${print_cta} with every order Today!</b></a>`;
      }
    }

    if(variation === "v1" || qa === "wndr26v1"){
      console.log("wndr26v1");
      waitForElement('.promo_banner p').then(promo => {
        waitForElement('.promo_banner_mobile p').then(promo_m => {
          promo.innerHTML = v1_html;
          promo_m.innerHTML = v1_html;
          promo_m.style.padding = ".25em 2em";
        }).catch();
      }).catch();
    }
    if(variation === "v2" || qa === "wndr26v2"){
      console.log("wndr26v2");
      waitForElement('.promo_banner p').then(promo => {
        waitForElement('.promo_banner_mobile p').then(promo_m => {
          promo.innerHTML = v2_html;
          promo_m.innerHTML = v2_html;
          promo_m.style.padding = ".25em 2em";
        }).catch();
      }).catch();
    }
  };

  const apply_wndr24 = () => {
    console.log("init WNDR-24 -- v0.1");
    waitForElement('#gorgias-chat-container').then(chat => {
      waitForElement('#nav').then(nav => {
        nav.classList.add("js-chat-trigger-added");
        // wait until Gorgias scripts have loaded
        waitForElement('iframe#chat-window').then(() => {
          waitForElement('iframe#chat-button').then(() => {
            let chat_active = GorgiasChat.isOpen();
            // let chat_active = false;
            if(!chat_active){
              chat.classList.add('js-hidden');
            }
          });
        });
        nav.insertAdjacentHTML("beforeend",`
        <a class="js-mobile-chat-trigger" id="launch-chat">
          <svg version="1.0" x="0px" y="0px" viewBox="0 0 100 100" enable-background="new 0 0 100 100" style="overflow: visible; shape-rendering: geometricprecision;"><filter id="33c9df204aeec9aa096f1fd360bd4160"><feGaussianBlur stdDeviation="0,4" in="SourceAlpha"></feGaussianBlur><feOffset dx="0" dy="4" result="offsetblur"></feOffset><feComponentTransfer><feFuncA type="linear" slope="0.4"></feFuncA></feComponentTransfer><feComposite operator="in" in2="offsetblur"></feComposite><feMerge><feMergeNode></feMergeNode><feMergeNode in="SourceGraphic"></feMergeNode></feMerge></filter><path fill="#fff" filter="#33c9df204aeec9aa096f1fd360bd4160" d="M50,0C22.4,0,0,22.4,0,50s22.4,50,50,50h30.8l0-10.6C92.5,80.2,100,66,100,50C100,22.4,77.6,0,50,0z M32,54.5 c-2.5,0-4.5-2-4.5-4.5c0-2.5,2-4.5,4.5-4.5s4.5,2,4.5,4.5C36.5,52.5,34.5,54.5,32,54.5z M50,54.5c-2.5,0-4.5-2-4.5-4.5 c0-2.5,2-4.5,4.5-4.5c2.5,0,4.5,2,4.5,4.5C54.5,52.5,52.5,54.5,50,54.5z M68,54.5c-2.5,0-4.5-2-4.5-4.5c0-2.5,2-4.5,4.5-4.5 s4.5,2,4.5,4.5C72.5,52.5,70.5,54.5,68,54.5z"></path></svg>
          Chat with our team
        </a>`);
        waitForElement('#launch-chat').then(trigger => {
          trigger.addEventListener("click",() => {
            chat.classList.remove('js-hidden');
            document.documentElement.classList.remove("mm-opening");
            GorgiasChat.open();
          })
        }).catch();
        waitForElement('.mm-navbar.mm-navbar-bottom.mm-navbar-bottom-1').then(el => {
          el.style.background = "#eee";
        })
      }).catch();
    }).catch();
  };

const apply_wndr33 = (active = true) => {
  console.log("init WNDR-33");

  waitForElement('.promo_banner').then(promo => {
    waitForElement('.promo_banner_mobile').then(promo_m => {

      setTimeout(() => {
        promo.classList.add("js-active");
        promo_m.classList.add("js-active");
      },100);

      if(active){

        window._shipScout = window._shipScout || [];
        _shipScout.push(function (response) {
          // console.log("_shipScout", response);

          /*
          example response object
          {
            testId: 1,
            testType: 'threshold',
            variant: 'B',
            threshold: true,
            freeShippingThresholdCents: 5000,
            shippingPriceCents: 1000
          }
          */

          let threshold_cents = (window.Shopify && Shopify.currency && Shopify.currency.rate) ? response.freeShippingThresholdCents * Shopify.currency.rate : response.freeShippingThresholdCents;
          let flatrate_cents = (window.Shopify && Shopify.currency && Shopify.currency.rate) ? response.shippingPriceCents * Shopify.currency.rate : response.shippingPriceCents;

          let currency_format = ShipScoutGetCurrency();
          let threshold_amount = ShipScoutFormatMoney(threshold_cents, currency_format);
          let flatrate_amount = ShipScoutFormatMoney(flatrate_cents, currency_format);

          //to avoid conflict with Sellry freegift promo bar
          document.body.insertAdjacentHTML("afterbegin",`
    			<style>
            .freegift_promo--bar{
              position: relative;
              z-index: 10;
              margin: -2em 0 0 0;
            }
    			</style>
    		  `);

          promo.insertAdjacentHTML("beforeend",`<div class="js-redbar-promo" style="position:relative; z-index:5;"></div>`);
          promo_m.insertAdjacentHTML("beforeend",`<div class="js-redbar-promo"  style="position:relative; z-index:5;"></div>`);

          waitForElement('.promo_banner .js-redbar-promo').then(promo_redbar => {
            waitForElement('.promo_banner_mobile .js-redbar-promo').then(promo_m_redbar => {

              let new_promo, new_promo_m;
              //if no announcement specified
              if(!promo.querySelector('p') || promo.querySelector('p').innerText.indexOf("Welcome all Wanderers!") > -1){
                new_promo = promo;
                new_promo_m = promo_m;
              } else {
                new_promo = promo_redbar;
                new_promo_m = promo_m_redbar;
              }

              /*if(Shopify.cart){
                if(Shopify.cart.total_price === 0){
                  new_promo.innerHTML = `<p><b>Orders ${threshold_amount} and over get FREE Shipping<p></b>`;
                  new_promo_m.innerHTML = `<p><b>Orders ${threshold_amount} and over get FREE Shipping<p></b>`;
                } else if(Shopify.cart.total_price < response.freeShippingThresholdCents){
                  new_promo.innerHTML = `<p><b>Add $${(response.freeShippingThresholdCents - Shopify.cart.total_price)/100} to get FREE Shipping<p></b>`;
                  new_promo_m.innerHTML = `<p><b>Add $${(response.freeShippingThresholdCents - Shopify.cart.total_price)/100} to get FREE Shipping<p></b>`;
                } else {
                  new_promo.innerHTML = `<p><b>Congratulations you get FREE Shipping<p></b>`;
                  new_promo_m.innerHTML = `<p><b>Congratulations you get FREE Shipping<p></b>`;
                }
              } else {
                new_promo.innerHTML = `<p><b>Orders ${threshold_amount} and over get FREE Shipping<p></b>`;
                new_promo_m.innerHTML = `<p><b>Orders ${threshold_amount} and over get FREE Shipping<p></b>`;
              }*/
            }).catch();
          }).catch();

          if(response.freeShippingThresholdCents === 2500) {
            console.log("_shipScout -- WNDR-33v0 -- Free Shipping $25+");
            ga('send', 'event', 'WNDR-33', 'conversion', 'v0: $25 threshold');
          } else if(response.freeShippingThresholdCents === 5000) {
            console.log("_shipScout -- WNDR-33v1 -- Free Shipping $50+");
            ga('send', 'event', 'WNDR-33', 'conversion', 'v1: $50 threshold');
          } else if(response.freeShippingThresholdCents === 4000) {
            console.log("_shipScout -- WNDR-33v2 -- Free Shipping $40+");
            ga('send', 'event', 'WNDR-33', 'conversion', 'v2: $40 threshold');
          } else {
            console.log("_shipScout -- WNDR-33vX -- Free Shipping Other");
            ga('send', 'event', 'WNDR-33', 'conversion', 'vX: other threshold');
          }
        }); // _shipScout.push()
      } // if(active)

    }).catch();
  }).catch();
};

//-----

const apply_wndr34 = () => {
  console.log("init WNDR-34");

  const wndr34_slider_html = `
  <div class="js-side-scroll">
    <ul>
      <li>
        <a href="/collections/coordinates-collection">
          <img src="https://cdn.shopify.com/s/files/1/0586/2621/files/img-circle-coordinates.png?v=1624410409&width=250" />
          <span>coordinates</span>
        </a>
      </li>
      <li>
        <a href="/collections/custom-initials-bracelets">
          <img src="https://cdn.shopify.com/s/files/1/0586/2621/files/img-circle-initials.png?v=1624410409&width=250" />
          <span>initials</span>
        </a>
      </li>
      <li>
        <a href="/collections/date-collection">
          <img src="https://cdn.shopify.com/s/files/1/0586/2621/files/img-circle-date.png?v=1624410409&width=250" />
          <span>date</span>
        </a>
      </li>
      <li>
        <a href="/collections/meaningful-symbol-bracelets">
          <img src="https://cdn.shopify.com/s/files/1/0586/2621/files/img-circle-symbols.png?v=1624410409&width=250" />
          <span>symbols</span>
        </a>
      </li>
      <li>
        <a href="/collections/custom-anchors">
          <img src="https://cdn.shopify.com/s/files/1/0586/2621/files/img-circle-anchor.png?v=1624410409&width=250" />
          <span>anchor</span>
        </a>
      </li>
      <li>
        <a href="/collections/infinity">
          <img src="https://cdn.shopify.com/s/files/1/0586/2621/files/img-circle-infinity.png?v=1624410409&width=250" />
          <span>infinity</span>
        </a>
      </li>
      <li>
        <a href="/collections/custom-initials-bracelets/products/custom-hook-bracelet-independence">
          <img src="https://cdn.shopify.com/s/files/1/0586/2621/files/img-circle-hook.png?v=1624410409&width=250" />
          <span>hook</span>
        </a>
      </li>
      <li>
        <a href="/collections/custom-initials-bracelets/products/horn-custom-arrow-bracelet-pair">
          <img src="https://cdn.shopify.com/s/files/1/0586/2621/files/img-circle-arrow.png?v=1624410409&width=250" />
          <span>arrow</span>
        </a>
      </li>
      <li>
        <a href="/collections/accent-collection">
          <img src="https://cdn.shopify.com/s/files/1/0586/2621/files/img-circle-accents.png?v=1624410409&width=250" />
          <span>accents</span>
        </a>
      </li>
      <li>
        <a href="/collections/anklet-collection">
          <img src="https://cdn.shopify.com/s/files/1/0586/2621/files/img-circle-anklets.png?v=1624410409&width=250" />
          <span>anklets</span>
        </a>
      </li>
      <li>
        <a href="/collections/accessories">
          <img src="https://cdn.shopify.com/s/files/1/0586/2621/files/img-circle-accessories.png?v=1624410409&width=250" />
          <span>accessories</span>
        </a>
      </li>
    </ul>
  </div>
  `;

  waitForElement('section.banner-section').then(banner => {
    banner.insertAdjacentHTML("beforebegin", wndr34_slider_html);
  }).catch();
};

//-----

waitUntil(() => {
  return sessionStorage.getItem("WNDR-35");
}).then(() => {
  let wndr35_var = sessionStorage.getItem("WNDR-35");
  switch (wndr35_var) {
    case "v0":
      console.log("Justuno -- WNDR-35v0 -- control");
      ga('send', 'event', 'WNDR-35', 'Justuno promo', 'v0: control');
      break;
    case "v0":
      console.log("Justuno -- WNDR-35v1 -- new artwork");
      ga('send', 'event', 'WNDR-35', 'Justuno promo', 'v1: new artwork');
      break;
    case "v0":
      console.log("Justuno -- WNDR-35v2 -- box pre-checked");
      ga('send', 'event', 'WNDR-35', 'Justuno promo', 'v2: box pre-checked');
      break;
    case "v0":
      console.log("Justuno -- WNDR-35v3 -- phone number only");
      ga('send', 'event', 'WNDR-35', 'Justuno promo', 'v3: phone number only'); 
      break;

  }
}).catch();

//-----

window.addEventListener('DOMContentLoaded', () => {

  console.log("init Proteus Treatments -- v0.03");

  //spotfix
  //change position of gorgias chat trigger
  if(document.body.classList.contains("product") && window.innerWidth < 500){
    // console.log("---mobile Specific");
    waitForElement('#chat-button').then(chat_btn => {
      // console.log("---see btn");
      waitForElement('.mobile-configurator__nav').then(el => {
        // console.log("---see el", el.offsetHeight);
        chat_btn.style.bottom = el.offsetHeight + "px";
        // console.log("---see el", el.offsetHeight);
      }).catch();
    }).catch();
  }

  let activate_wndr24 = false;
  // if(sessionStorage.getItem("proteus") === "WNDR-24" || getParam("qa") === "wndr24"){
  if(window.innerWidth < 768){
    activate_wndr24 = true;
  }

  if(activate_wndr24){
    apply_wndr24();
  }

  waitUntil(() => {
    return sessionStorage.getItem("WNDR-26") || getParam("qa").indexOf("wndr26") > -1;
  }).then(() => {
    apply_wndr26();
  }).catch();

  waitUntil(() => {
    return sessionStorage.getItem("WNDR-27") || getParam("qa").indexOf("wndr27") > -1;
  }).then(() => {
    apply_wndr27();
  }).catch();

  waitUntil(() => {
    return sessionStorage.getItem("WNDR-33") || getParam("qa").indexOf("wndr33") > -1;
  }).then(() => {
    apply_wndr33();
  }).catch();

  //_shipScout
  apply_wndr33();

  waitUntil(() => {
    return sessionStorage.getItem("WNDR-34") || getParam("qa").indexOf("wndr34") > -1;
  }).then(() => {
    apply_wndr34();
  }).catch();

});

/*
document.onreadystatechange = () => {
  if (document.readyState === 'complete') {
  }
}
*/
